module.exports = __webpack_public_path__ + "img/sponsorB16.65741598.png";